import {
  LOAD_RBAC_ITEMS,
  LOAD_RBAC_ITEMS_SUCCESS,
  LOAD_USER_PERMISSIONS,
  LOAD_USER_PERMISSIONS_SUCCESS,
} from 'constants/ActionTypes';

// Begin to load rbac auth items
export const loadRbacItems = () => {
  return {
    type: LOAD_RBAC_ITEMS,
  };
};

// Successfully load rbac items
export const loadRbacItemsSuccess = (items) => {
  return {
    type: LOAD_RBAC_ITEMS_SUCCESS,
    items,
  };
};

export const loadUserPermissions = () => {
  return {
    type: LOAD_USER_PERMISSIONS,
  };
};

export const loadUserPermissionsSuccess = (permissions) => {
  return {
    type: LOAD_USER_PERMISSIONS_SUCCESS,
    permissions,
  };
};
